import { Box } from '@mui/material'
import ApiClient from '../../backend/ApiClient'
import { IClaimDetails } from '../../definitions/Claims'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import SmartTable from './table/SmartTable'
import { SmartTableUtilities } from './table'

interface P {
    claim: IClaimDetails
    contractId?: number
    hideMemberId?: boolean
}

function ClaimLinesTable({ claim, contractId, hideMemberId }: P) {
    const { status, response: claimLines } = useQuery({
        queryKey: buildQueryKey('ClaimLinesTable', contractId, claim.id),
        queryFn: () => ApiClient.getClaimLines(claim.id, contractId),
        cache: true
    })

    return (
        <Box sx={{ padding: 1 }}>
            <SmartTable
                isLoading={status === 'loading'}
                columns={[
                    { id: 'providername', label: 'Provider' },
                    { id: 'fundname', label: 'Fund' },
                    { id: 'icd10Codename', label: 'ICD 10 Code' },
                    { id: 'status', label: 'Status' },
                    { id: 'isBadClaim', label: 'Is Bad Claimline' },
                    ...(!hideMemberId ? [{ id: 'member', label: 'Member' }] : []),
                    { id: 'payment', label: 'Payment' }
                ]}
                noCollapse
                datasource={{
                    rows: (claimLines ?? [])?.map((x, i) => SmartTableUtilities.toRow([
                        { value: x?.provider?.name },
                        { value: x?.fund?.name ?? ' ' },
                        { value: x?.icd10Code?.name },
                        { value: x?.status },
                        { value: x?.isBadClaim?.toString() },
                        ...(!hideMemberId ? [{ value: x?.member?.attributedMemberId }] : []),
                        { value: x?.payment }
                    ], i))
                }}
            />
        </Box>
    )
}

export default ClaimLinesTable
